import { request } from '@/utils/request'

export function getDictionaryAirports () {
  return request({
    url: 'dictionary/airports',
    method: 'get'
  })
}

export function getCodeDictionaries () {
  return request({
    url: 'dictionary/codes',
    method: 'get'
  })
}
